// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-37122228] .fa-calendar-day {\n  font-weight: 500 !important;\n}\n.custom-background[data-v-37122228] {\n  background-color: #f7f7f7;\n  padding: 1%;\n}", ""]);
// Exports
module.exports = exports;
